// Типы действий среза app (авторизация + ui).
export const SET_IS_LOAD = 'app/SET_IS_LOAD';
export const SET_TITLE = 'app/SET_TITLE';
export const SET_AUTH_DATA = 'app/SET_AUTH_DATA';
export const CLEAR_AUTH_DATA = 'app/CLEAR_AUTH_DATA';
export const SET_FILTER = 'app/SET_FILTER';
export const SET_REFRESH_INTERVAL = 'app/SET_REFRESH_INTERVAL';
export const SET_PAGE_REFRESH_INTERVAL = 'app/SET_PAGE_REFRESH_INTERVAL';
export const SET_MENU_GROUP_STATE = 'app/SET_MENU_GROUP_STATE';
